/**
 * Grail27 — show cart add errors (e.g. inventory limits) via Dawn cart-error pub/sub.
 */
(function () {
  if (window.__grailCartErrorBound) return;
  window.__grailCartErrorBound = true;

  var toast;
  var messageEl;
  var hideTimer;
  var lastMessage = '';
  var lastShownAt = 0;

  function getErrorText(event) {
    if (!event) return 'Unable to add this item to your cart.';

    if (typeof event.errors === 'string' && event.errors.trim()) {
      return event.errors.trim();
    }

    if (event.errors && typeof event.errors === 'object') {
      var parts = Object.values(event.errors)
        .flat()
        .filter(Boolean);
      if (parts.length) return parts.join(' ');
    }

    if (typeof event.message === 'string' && event.message.trim() && event.message !== 'Cart Error') {
      return event.message.trim();
    }

    if (typeof event.description === 'string' && event.description.trim()) {
      return event.description.trim();
    }

    return 'Unable to add this item to your cart.';
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.clearTimeout(hideTimer);
  }

  function showToast(event) {
    if (window.GrailCartUi) {
      window.GrailCartUi.showError(event);
      return;
    }
    var text = typeof event === 'string' ? event : getErrorText(event);
    if (!toast || !messageEl || !text) return;

    var now = Date.now();
    if (text === lastMessage && now - lastShownAt < 1200) return;

    lastMessage = text;
    lastShownAt = now;
    messageEl.textContent = text;
    toast.classList.add('is-visible');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hideToast, 5000);
  }

  function init() {
    toast = document.getElementById('grail-cart-error-toast');
    messageEl = document.getElementById('grail-cart-error-toast-message');
    if (!toast || !messageEl) return;

    var closeBtn = toast.querySelector('[data-grail-cart-error-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', hideToast);
    }

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (event && event.source && event.source !== 'product-form') return;
      showToast(event);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
